import * as React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import { headerHeightPc, headerHeightSp, mq } from 'style/variables';
import InquiryBlock from 'components/organisms/inquiryBlock/';
import { TextSet } from 'components/molecules/textSet/';
import { JaHeading } from 'components/atoms/jaHeading/';
import { List } from 'components/atoms/list/';
import { Text } from 'components/atoms/text/';
import { EnHeading } from 'components/atoms/enHeading';
import { graphql } from 'gatsby';
import SEO from 'util/seo';
import { useEffect } from 'react';
import ParticleImageManager from 'components/organisms/particleCanvas/ParticleImageManager';
import { contentWrapper } from 'style/mixin';

interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string;
      };
    };
  };
}

const PrivacyWrap = styled.div`
  ${contentWrapper}
`;

const TitleSection = styled.div`
  ${mq.onlypc} {
    padding-top: ${sizes.margin[180]};
    padding-bottom: ${sizes.margin[100]};
  }
  ${mq.onlysp} {
    padding-top: ${sizes.margin[155]};
    padding-bottom: ${sizes.margin[64]};
  }
`;

const PrivacySectionWrap = styled.div`
  padding-bottom: ${sizes.margin[100]};
`;

const PrivacySection = styled.div`
  ${mq.onlypc} {
    max-width: 700px;
    margin: 0 auto;
  }
  ul {
    margin-top: ${sizes.margin[32]};
  }
`;

const Pages: React.FC<IndexPageProps> = () => {
  useEffect(() => {
    ParticleImageManager.loadAll().then(() => {
      ParticleImageManager.generateAll().then(() => {
        ParticleImageManager.start();
      });
    });

    return () => {
      ParticleImageManager.delete();
    };
  }, []);

  return (
    <>
      <SEO title={'นโยบายความเป็นส่วนตัว'} />
      <PrivacyWrap>
        <TitleSection>
          <EnHeading>
            Privacy <br className="only-sp" />
            Policy
          </EnHeading>
        </TitleSection>

        <PrivacySectionWrap>
          <PrivacySection>
            <TextSet>
              <JaHeading size={'middle'}>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</JaHeading>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 1 บทนำ</JaHeading>
              <Text>บริษัท โฟร์ดิจิท (ประเทศไทย) จำกัด (ต่อไปนี้เรียกว่า "บริษัท") ซึ่งจัดตั้งขึ้นตาม กฎหมายของราชอาณาจักรไทย มุ่งมั่นที่จะจัดการและปกป้องข้อมูลส่วนบุคคลอย่าง เหมาะสม โดยปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (ต่อไปนี้ เรียกว่า "PDPA") และกฎหมายอื่นๆ ที่เกี่ยวข้องในการจัดการข้อมูลส่วนบุคคลทั้งใน ประเทศไทยและระหว่างบริษัทในเครือ</Text>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 2 คำนิยาม</JaHeading>

              <List>
                <li>"ข้อมูลส่วนบุคคล" หมายถึง ข้อมูลใดๆ ที่สามารถระบุตัวบุคคลได้ไม่ว่าโดยทางตรงหรือ
ทางอ้อม รวมถึงชื่อ ที่อยู่ ข้อมูลติดต่อ หมายเลขประจำตัว อีเมล รูปถ่าย เป็นต้น</li>
                <li>"ข้อมูลส่วนบุคคลที่มีความอ่อนไหว" หมายถึง ข้อมูลที่ได้รับการคุ้มครองเป็นพิเศษตาม PDPA เช่น ข้อมูลสุขภาพ ศาสนาหรือความเชื่อ ความคิดเห็นทางการเมือง รสนิยมทางเพศ ประวัติอาชญากรรม เป็นต้น</li>
                <li>"เจ้าของข้อมูล" หมายถึง บุคคลธรรมดาที่เป็นเจ้าของข้อมูลส่วนบุคคล</li>
                <li>"ผู้ควบคุมข้อมูล" หมายถึง บุคคลหรือนิติบุคคลที่มีอำนาจในการตัดสินใจเกี่ยวกับ
วัตถุประสงค์และวิธีการในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล</li>
                <li>"ผู้ประมวลผลข้อมูล" หมายถึง บุคคลหรือนิติบุคคลที่ดำเนินการเกี่ยวกับการเก็บ
รวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งของผู้ควบคุมข้อมูล</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 3 ความมุ่งมั่นในการคุ้มครองข้อมูลส่วนบุคคล</JaHeading>

              <Text>บริษัทจะดำเนินการกับข้อมูลส่วนบุคคลตามหลักการดังต่อไปนี้:</Text>
              <List>
                <li>ประมวลผลข้อมูลส่วนบุคคลอย่างถูกกฎหมาย เป็นธรรม และโปร่งใส</li>
                <li>กำหนดวัตถุประสงค์ที่ชัดเจนและใช้ข้อมูลเฉพาะในขอบเขตของวัตถุประสงค์นั้น</li>
                <li>เก็บรักษาข้อมูลเฉพาะในระยะเวลาที่จำเป็นและลบหรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้เมื่อไม่จำเป็นต้องใช้อีกต่อไป</li>
                <li>ใช้มาตรการทางเทคนิคและองค์กรที่เหมาะสมเพื่อป้องกันการเข้าถึงโดยไม่ได้รับอนุญาต 
การรั่วไหล การสูญหาย หรือความเสียหายของข้อมูล</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 4 วัตถุประสงค์ในการใช้ข้อมูลส่วนบุคคล</JaHeading>

              <Text>บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้:</Text>
              <List>
                <li>การให้บริการและสินค้า การปฏิบัติตามสัญญา การตอบข้อซักถาม</li>
                <li>การปรับปรุงบริการ การพัฒนาบริการใหม่ การวิเคราะห์ภายใน</li>
                <li>การปฏิบัติตามกฎหมาย การบันทึก การบัญชี และหน้าที่เกี่ยวกับภาษีอากร</li>
                <li>การแลกเปลี่ยนข้อมูลกับบริษัทในเครือและพันธมิตรทางธุรกิจในการทำงานร่วมกัน</li>
                <li>วัตถุประสงค์อื่นๆ ที่ได้รับความยินยอมจากเจ้าของข้อมูล</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 5 ประเภทของข้อมูลส่วนบุคคลที่เก็บรวบรวมและประมวลผล</JaHeading>

              <List>
                <li>ชื่อ-สกุล เพศ วันเดือนปีเกิด ที่อยู่ ข้อมูลติดต่อ (เบอร์โทรศัพท์ อีเมล ฯลฯ) สัญชาติ</li>
                <li>หมายเลขบัตรประจำตัวประชาชน หมายเลขพาสปอร์ต หรือข้อมูลระบุตัวตนอื่นๆ</li>
                <li>ข้อมูลที่ทำงาน ตำแหน่ง</li>
                <li>ประวัติการใช้บริการ บันทึกการติดต่อ ภาพและวิดีโอ</li>
                <li>ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (จำเป็นต้องได้รับความยินยอมที่ชัดเจนหากมีความจำเป็นต้องเก็บรวบรวม)</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 6 วิธีการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคล</JaHeading>

              <List>
                <li>การเก็บรวบรวมผ่านเว็บไซต์ แอปพลิเคชัน สัญญา กิจกรรม บริษัทในเครือ และ
	พันธมิตรทางธุรกิจ</li>
                <li>เมื่อมีการเก็บรวบรวมข้อมูล บริษัทจะแจ้งให้ทราบถึงวัตถุประสงค์ การเปิดเผยต่อ
	บุคคลที่สาม การโอนข้อมูลข้ามประเทศ และจะขอความยินยอมเมื่อจำเป็น</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 7 ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคล</JaHeading>

              <Text>บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลเฉพาะในระยะเวลาที่จำเป็นเพื่อบรรลุวัตถุ ประสงค์ ปฏิบัติตามกฎหมาย และการระงับข้อพิพาท และจะลบหรือทำให้ข้อมูลไม่ สามารถระบุตัวบุคคลได้เมื่อไม่จำเป็นต้องใช้อีกต่อไป</Text>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 8 การเปิดเผยข้อมูลแก่บุคคลที่สามและการโอนข้อมูลข้ามประเทศ</JaHeading>

              <List>
                <li>บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลให้แก่ผู้รับจ้าง บริษัทในเครือ และพันธมิตรทาง
	ธุรกิจ โดยจะมีการจัดทำสัญญาและมาตรการการจัดการที่เหมาะสมตาม PDPA</li>
                <li>ในกรณีที่มีการโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ บริษัทจะดำเนินการตาม
	PDPA และกฎหมายลำดับรองที่เกี่ยวข้อง โดยจะตรวจสอบว่าประเทศปลายทางมี
	มาตรการคุ้มครองที่เพียงพอ และจะขอความยินยอมจากเจ้าของข้อมูลเมื่อจำเป็น</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 9 สิทธิของเจ้าของข้อมูล</JaHeading>

              <Text>เจ้าของข้อมูลมีสิทธิดังต่อไปนี้:</Text>
              <List>
                <li>สิทธิในการขอแจ้งและเข้าถึงข้อมูลเกี่ยวกับวัตถุประสงค์และข้อมูลที่ถูกเก็บรวบรวม</li>
                <li>สิทธิในการขอแก้ไขและปรับปรุงข้อมูล</li>
                <li>สิทธิในการขอลบหรือทำลายข้อมูล</li>
                <li>สิทธิในการขอระงับการประมวลผลหรือการใช้ข้อมูล</li>
                <li>สิทธิในการถอนความยินยอม (โดยไม่กระทบต่อความชอบด้วยกฎหมายของการ
	ประมวลผลก่อนการถอนความยินยอม)</li>
                <li>สิทธิในการคัดค้าน และสิทธิในการเรียกร้องค่าเสียหาย</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 10 มาตรการการรักษาความปลอดภัย</JaHeading>

              <List>
                <li>บริษัทจะใช้มาตรการรักษาความปลอดภัยทางเทคนิค กายภาพ และองค์กร เพื่อ
	ป้องกันการรั่วไหล สูญหาย หรือเสียหายของข้อมูลส่วนบุคคล</li>
                <li>ในกรณีที่เกิดการรั่วไหลของข้อมูล บริษัทจะรายงานต่อคณะกรรมการคุ้มครอง
	ข้อมูลส่วนบุคคล (PDPC) และแจ้งให้เจ้าของข้อมูลทราบโดยเร็ว</li>
              </List>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 11 เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO)</JaHeading>
              <Text>บริษัทจะแต่งตั้งเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO) เมื่อกฎหมายกำหนด หรือเมื่อเห็นว่าจำเป็น เพื่อจัดการ ให้การศึกษา และกำกับดูแลการปฏิบัติตาม นโยบายภายในองค์กร</Text>
            </TextSet>

            <TextSet>
              <JaHeading size={'small'}>ข้อ 12 การแก้ไขและกฎหมายที่ใช้บังคับ</JaHeading>

              <List>
                <li>นโยบายนี้เป็นไปตาม PDPA และกฎหมายที่เกี่ยวข้อง และอาจมีการแก้ไขเมื่อจำเป็น</li>
                <li>การตีความและการบังคับใช้นโยบายนี้อยู่ภายใต้กฎหมายของราชอาณาจักรไทย</li>
              </List>
            </TextSet>

            <TextSet>
              <Text>
                <b>【ช่องทางการติดต่อสอบถามเกี่ยวกับนโยบายคุ้มครองข้อมูลส่วนบุคคล】</b>
                <br />
บริษัท โฟร์ดิจิท (ประเทศไทย) จำกัด
                <br />
	email : contact.th@4digit.jp
              </Text>
            </TextSet>
          </PrivacySection>
        </PrivacySectionWrap>

      </PrivacyWrap>

      <InquiryBlock th />
    </>
  );
};

export default Pages;

export const pageQuery = graphql`
  query privacyQueryTh {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
